import useTranslation from "@/hooks/useTranslation";
import { randomSearchBg } from "@/utils/common.util";
import { SearchOutlined } from "@ant-design/icons";
import { AutoComplete, Input } from "antd";
import React, { useEffect, useState } from "react";
import styles from "./styles.module.less";

const { wrapper, container, top, bottom, bottomHead, bottomSearch } = styles;

export interface IAcProps {
  acOptions: { value: any; label: any }[];
  handleChange?: (value: string) => void;
}

interface IProps {
  term: string;
  title: string;
  slogan: string;
  placeholder: string;
  statement: string;
  handleChange?: (value: string) => void;
  acOptions?: { label?: any; value: any }[];
  handleSelect?: (value: string) => void;
  handleSearch: (value: string) => void;
  loadingSearch: boolean;
}

const Hero: React.FC<IProps> = (props) => {
  const {
    placeholder,
    handleSearch,
    title,
    slogan,
    statement,
    handleChange,
    acOptions,
    handleSelect,
    term,
    loadingSearch,
  } = props;

  const [bgImage, setBgImage] = useState(null);

  useEffect(() => {
    setBgImage(randomSearchBg());
  }, []);
  const { t } = useTranslation("common");

  const [open, setOpen] = useState(false);

  return (
    <div
      className={wrapper}
      style={{ backgroundImage: bgImage ? `url("${bgImage}")` : "none" }}
    >
      <div className={container}>
        <div className={top}>
          <div>{title}</div>
          <div>{statement}</div>
        </div>
        <div className={bottom}>
          <div className={bottomHead}>{slogan}</div>
          <div className={bottomSearch}>
            <AutoComplete
              options={acOptions}
              style={{ width: "100%" }}
              onSelect={handleSelect}
              onChange={handleChange}
              open={open}
              onFocus={() => setOpen(true)}
              onBlur={() => setOpen(false)}
            >
              <Input.Search
                size="large"
                addonBefore={
                  <SearchOutlined
                    spin={loadingSearch}
                    className={styles.icon}
                  />
                }
                enterButton={t("search")}
                placeholder={placeholder}
                onPressEnter={(e) => e.preventDefault()}
                onSearch={(value: string) => {
                  if (value) {
                    handleSearch(value);
                  }
                }}
                allowClear
                disabled={loadingSearch}
                defaultValue={term}
              />
            </AutoComplete>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;
